export class PrimaryMobileNav extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.setupMenuToggle()
    this.setupNestedMenus()
    this.setupBackButton()
  }

  setupBackButton () {
    const backButton = this.externalEls.back.element
    if (backButton) {
      backButton.addEventListener('click', () => {
        const primaryNavItems = this.els.primary.elements
        primaryNavItems.forEach(item => {
          item.classList.remove('nav-Submenu_Open')
          const submenu = item.querySelector('[data-submenu]')
          if (submenu) {
            submenu.setAttribute('aria-hidden', 'true')
          }
        })

        const logo = this.externalEls.logo.element
        logo.setAttribute('aria-hidden', 'false')
        backButton.setAttribute('aria-hidden', 'true')
      })
    }
  }

  setupNestedMenus () {
    const primaryNavItems = this.els.primary.elements

    primaryNavItems.forEach(item => {
      item.addEventListener('click', (event) => {
        if (event.target.classList.contains('nav-Mobile_Link')) return

        const submenu = item.querySelector('[data-submenu]')
        if (submenu) {
          const isHidden = submenu.getAttribute('aria-hidden') === 'true'
          item.classList.toggle('nav-Submenu_Open', !!isHidden)
          submenu.setAttribute('aria-hidden', isHidden ? 'false' : 'true')

          const logo = this.externalEls.logo.element
          const backText = this.externalEls.back.element

          logo.setAttribute('aria-hidden', isHidden ? 'true' : 'false')
          backText.setAttribute('aria-hidden', isHidden ? 'false' : 'true')
        }
      })
    })
  }

  setupMenuToggle () {
    const burgerButton = this.externalEls.burger.element
    const closeButton = this.externalEls.close.element

    if (burgerButton) {
      burgerButton.addEventListener('click', () => {
        const isHidden = closeButton.getAttribute('aria-hidden') === 'true'
        closeButton.setAttribute('aria-hidden', isHidden ? 'false' : 'true')
        burgerButton.setAttribute('aria-hidden', isHidden ? 'true' : 'false')
        document.body.classList.toggle('util-SiteOverflowed', isHidden)

        this.externalEls.back.element.click()
      })
    }

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        burgerButton.click()
      })
    }
  }
}

customElements.define('primary-mobile-nav', PrimaryMobileNav)
